import { Component, Input, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager'


@Component({
  selector: 'app-zuli',
  templateUrl: './dobra-zuli.component.html',
  styleUrls: ['./dobra-zuli.component.scss']
})
export class DobraZuliComponent implements OnInit {
  @Input() hiddenCta: boolean = false

  constructor(private gtmService: GoogleTagManagerService) { }

  ngOnInit(): void {


  }


}
